const applicationConfig = {
  apiBaseUrl: 'https://cattlyticsapi.azurewebsites.net/api/'
  // apiBaseUrl: 'https://localhost:5001/api/'
}

export default applicationConfig
